import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'dashboard' }
      },
      {
        path: 'system',
        name: 'System',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/system/user',
        meta: { title: '系统管理', icon: 'system' },
        children: [
          {
            path: 'user',
            name: 'User',
            component: () => import('@/views/system/User.vue'),
            meta: { title: '用户管理', icon: 'user' }
          },
          {
            path: 'role',
            name: 'Role',
            component: () => import('@/views/system/Role.vue'),
            meta: { title: '角色管理', icon: 'peoples' }
          },
          {
            path: 'menu',
            name: 'Menu',
            component: () => import('@/views/system/Menu.vue'),
            meta: { title: '菜单管理', icon: 'tree-table' }
          },
          {
            path: 'log',
            name: 'Log',
            component: () => import('@/views/system/Log.vue'),
            meta: { title: '日志管理', icon: 'log' }
          },
          {
            path: 'customer',
            name: 'Customer',
            component: () => import('@/views/system/Customer.vue'),
            meta: { title: '客户管理', icon: 'user-solid' }
          },
          {
            path: 'backend-config',
            name: 'BackendConfig',
            component: () => import('@/views/system/BackendConfig.vue'),
            meta: { title: '后台配置', icon: 'setting' }
          }
        ]
      },
      {
        path: 'info',
        name: 'Info',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/info/sanwan',
        meta: { title: '信息管理', icon: 'documentation' },
        children: [
          {
            path: 'sanwan',
            name: 'Sanwan',
            component: () => import('@/views/info/Sanwan.vue'),
            meta: { title: '天然良港', icon: 'place' }
          },
          {
            path: 'huanzu',
            name: 'Huanzu',
            component: () => import('@/views/info/Huanzu.vue'),
            meta: { title: '皇族南迁', icon: 'place' }
          },
          {
            path: 'jishu',
            name: 'Jishu',
            component: () => import('@/views/info/Jishu.vue'),
            meta: { title: '技术领航', icon: 'place' }
          },
          {
            path: 'tihang',
            name: 'Tihang',
            component: () => import('@/views/info/Tihang.vue'),
            meta: { title: '梯航万国', icon: 'place' }
          },
          {
            path: 'gujin',
            name: 'Gujin',
            component: () => import('@/views/info/Gujin.vue'),
            meta: { title: '古今辉映', icon: 'place' }
          }
        ]
      },
      {
        path: 'knowledge',
        name: 'Knowledge',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/knowledge/category',
        meta: { title: '知识库', icon: 'folder' },
        children: [
          {
            path: 'category',
            name: 'KnowledgeCategory',
            component: () => import('@/views/knowledge/Category.vue'),
            meta: { title: '类别管理', icon: 'folder-opened' }
          },
          {
            path: 'entry',
            name: 'KnowledgeEntry',
            component: () => import('@/views/knowledge/Entry.vue'),
            meta: { title: '条目管理', icon: 'document' }
          }
        ]
      },
      {
        path: 'question',
        name: 'Question',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/question/bank',
        meta: { title: '互动答题', icon: 'edit' },
        children: [
          {
            path: 'bank',
            name: 'QuestionBank',
            component: () => import('@/views/question/QuestionBank.vue'),
            meta: { title: '题库管理', icon: 'document' }
          },
          {
            path: 'answer-stats',
            name: 'QuestionAnswerStats',
            component: () => import('@/views/question/AnswerStats.vue'),
            meta: { title: '答题情况', icon: 'data-analysis' }
          },
          {
            path: 'answer-report',
            name: 'QuestionAnswerReport',
            component: () => import('@/views/question/AnswerReport.vue'),
            meta: { title: '答题统计', icon: 'pie-chart' }
          }
        ]
      },
      {
        path: 'checkin',
        name: 'Checkin',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/checkin/record',
        meta: { title: '互动打卡', icon: 'date' },
        children: [
          {
            path: 'point',
            name: 'CheckinPoint',
            component: () => import('@/views/knowledge/CheckinPoint.vue'),
            meta: { title: '打卡点管理', icon: 'location-outline' }
          },
          {
            path: 'record',
            name: 'CheckinRecord',
            component: () => import('@/views/knowledge/CheckinRecord.vue'),
            meta: { title: '打卡记录', icon: 'document' }
          },
          {
            path: 'stat',
            name: 'CheckinStat',
            component: () => import('@/views/knowledge/CheckinStat.vue'),
            meta: { title: '打卡统计', icon: 'data-analysis' }
          }
        ]
      },
      {
        path: 'guestbook',
        name: 'Guestbook',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/guestbook/messages',
        meta: { title: '留言管理', icon: 'el-icon-chat-dot-round' },
        children: [
          {
            path: 'messages',
            name: 'GuestbookMessages',
            component: () => import('@/views/guestbook/MessageManage.vue'),
            meta: { title: '留言列表', icon: 'document' }
          }
        ]
      },
      {
        path: 'platform',
        name: 'Platform',
        component: () => import('@/layout/Blank.vue'),
        redirect: '/platform/visit',
        meta: { title: '平台运行情况', icon: 'data-board' },
        children: [
          {
            path: 'visit',
            name: 'PlatformVisitStat',
            component: () => import('@/views/platform/VisitStat.vue'),
            meta: { title: '访问量统计', icon: 'histogram' }
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
      return Promise.reject(err)
    }
  })
}
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
      return Promise.reject(err)
    }
  })
}

router.beforeEach((to, from, next) => {
  const token = store.getters['user/token']
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (token) {
      if (store.getters['user/menus'].length === 0) {
        store.dispatch('user/getMenus').then(() => next())
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

export default router
